import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FULLSCREEN_FEATURE_KEY } from './fullscreen.reducer';
import { FullscreenState } from './fullscreen.models';

export const fullscreenSelector = createFeatureSelector<FullscreenState>(FULLSCREEN_FEATURE_KEY);
// eslint-disable-next-line
export const getFullscreenState = () =>
  createSelector(fullscreenSelector, (state: FullscreenState) => state.fullscreenState);
